import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import RewardsContent from './RewardsContent';
import TimelineContent from './TimelineContent';
import PointsContent from './PointsContent';
import ReviewContent from './ReviewContent';
import TrackContent from './TrackContent';
import TimelineList from './TimelineList';
import ActivitiesContent from './ActivitiesContent';
import Header from '../../layout/Header';


const Reward = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState('select_reward');
  const [formData, setFormData] = useState({
    RewardsDetails: null,
    Timeline: null,
    points: null,
    Activity: null,
  });

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tab = queryParams.get('tab');
    if (tab) {
      setActiveSection(tab);
    }
  }, [location]);

  const handleSectionClick = (sectionId) => {
    setActiveSection(sectionId);
    navigate(`?tab=${sectionId}`); 
  };

  const updateFormData = (section, data) => {
    setFormData((prev) => ({ ...prev, [section]: data }));
  };

  const sectionOrder = [
    'select_reward',
    'achievement_timeline',
    'points_timeline',
    'activities_timeline',
    'review_timeline',
    'track_timeline',
  ];

  const goToPreviousTab = () => {
    const currentIndex = sectionOrder.indexOf(activeSection);
    if (currentIndex > 0) {
      const previousSection = sectionOrder[currentIndex - 1];
      setActiveSection(previousSection);
      navigate(`?tab=${previousSection}`);
    } else {
      navigate('/home');
    }
  };

  return (
    <>
      <Header goToPreviousTab={goToPreviousTab} isHomePage={false} />
      <main>
        <div className="timeline">
          {/* <TimelineList activeSection={activeSection} onSectionClick={handleSectionClick} /> */}
          <div className="timeline-content">
            {activeSection === 'select_reward' && (
              <RewardsContent
                updateFormData={(data) => updateFormData('RewardsDetails', data)}
                setActiveSection={setActiveSection}
                formData={formData}
              />
            )}
            {activeSection === 'achievement_timeline' && (
              <TimelineContent
                updateFormData={(data) => updateFormData('Timeline', data)}
                setActiveSection={setActiveSection}
                formData={formData}
              />
            )}
            {activeSection === 'points_timeline' && (
              <PointsContent
                updateFormData={(data) => updateFormData('points', data)}
                setActiveSection={setActiveSection}
                formData={formData}
              />
            )}
            {activeSection === 'activities_timeline' && (
              <ActivitiesContent
                updateFormData={(data) => updateFormData('Activity', data)}
                setActiveSection={setActiveSection}
                formData={formData}
              />
            )}
            {activeSection === 'review_timeline' && (
              <ReviewContent
                setActiveSection={setActiveSection}
                formData={formData}
              />
            )}
            {activeSection === 'track_timeline' && (
              <TrackContent
                updateFormData={(data) => updateFormData('track', data)}
                setActiveSection={setActiveSection}
                formData={formData}
              />
            )}
          </div>
        </div>
      </main>
    </>
  );
};

export default Reward;
